import { Modal } from "flowbite";
import Toastify from "toastify-js";

/**
 * Initializes and displays a Toastify notification based on the AJAX response.
 * @param {object} response - The JSON response from the server.
 * @param {Modal} modal - The Flowbite Modal instance.
 */
const initToast = (response, modal) => {
  Toastify({
    text: response.data.message,
    duration: 2000,
    gravity: "bottom", // `top` or `bottom`
    position: "right", // `left`, `center` or `right`,
    className: "rounded-md shadow",
    style: { background: "#000000", },
    callback: () => {
      if (response.data.success) {
        // 🔥 Uncommented: Hides modal and reloads page on successful deletion
        modal.hide();
        location.reload(); 
      }
    }
  }).showToast();
}

/**
 * Initializes the modal and handles the deletion of a teacher via AJAX.
 */
const deleteTeacher = () => {
  // Get the modal element
  const targetEl = document.getElementById("modalDeleteTeacher");

  if (targetEl) {
    const triggers = document.querySelectorAll(".js-deleteUser");

    // Create modal options
    const options = {
      placement: "center-center",
      backdrop: "dynamic",
      backdropClasses:
        "bg-gray-900 bg-opacity-60 backdrop-blur fixed inset-0 z-40",
      closable: true,
    };

    // Initialise modal
    const modal = new Modal(targetEl, options);

    let currentMentorName = document.querySelector(".js-mentorName");
    let currentMentorID = document.querySelector("#current_mentor_id");
    
    // Get the teacher form once
    let form = document.getElementById("delete_teacher_form");
    
    // 🛑 CRITICAL FIX: The submit listener has been removed from the form.
    // The AJAX request is now triggered only by the #accept button's click event.

    // open modal via triggers and populate the data accordingly
    triggers.forEach((el) => {
      el.addEventListener("click", (e) => {
        currentMentorName.textContent = el.dataset.teacherName;
        currentMentorID.value = el.dataset.teacherId;
        if (modal.isHidden()) {
          modal.show();
        }
      });
    });

    // close modal if close or cancel clicked
    document.querySelectorAll(".js-close-modalDeleteTeacher").forEach((el) => {
      el.addEventListener("click", () => {
        if (modal.isVisible()) {
          modal.hide();
        }
      });
    });

    // 🔥 FIX: The AJAX call is now handled directly by the #accept button's click listener.
    // This prevents the double submission issue.
    document.querySelector("#accept").addEventListener("click", (ev) => {
      // Prevents native form submission if #accept is a <button type="submit">
      ev.preventDefault(); 
      
      if (modal.isVisible() && form) {

        // Get form data
        const data = new FormData(form);
        data.append("action", "delete_teacher");
        
        // Make the AJAX request
        fetch("/wp-admin/admin-ajax.php", { method: "POST", body: data })
          .then((response) => response.json())
          .then((response) => {
            console.log(response); // <-- Logs only once now!
            initToast(response, modal);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });

  }
};

export { deleteTeacher };